import PoliticalRepresentativesComponent from "../PoliticalRepresentativesComponent";

export default function () {
    return (
        <>
            <div className="card">
                <PoliticalRepresentativesComponent header={"Political Party"} />
            </div>
        </>
    );
}
